import { useMemo, useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import {
  RecordingsDataRow,
  RecordingsDataRowAdapter,
} from "./RecordingsDataRow";
import { ColDef, IDetailCellRendererParams } from "@ag-grid-community/core";
import { useRecordedService } from "../../api/recordedService";
import { formatCurrency } from "../../utils/numberFormatters";

const RecordedAnalytics = () => {
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  const [rowData, setRowData] = useState<RecordingsDataRow[]>();
  const { recorded } = useRecordedService();

  useEffect(() => {
    if (!recorded?.length) return;
    const finalOutput = new RecordingsDataRowAdapter().toRecordingsData(
      recorded
    );
    setRowData(finalOutput);
  }, [recorded]);

  const defaultColDef = useMemo<ColDef>(() => {
    return {
      flex: 1,
      aggFunc: "count",
      minWidth: 250,
      filter: true,
      resizable: true,
      enableRowGroup: true,
    };
  }, []);

  const detailCellRendererParams = useMemo<any>(() => {
    return {
      detailGridOptions: {
        columnDefs: [
          { field: "title", headerName: "Title" },
          { field: "type", headerName: "Type" },
          {
            field: "streamRevenue",
            headerName: "Stream Revenue",
            valueFormatter: (p: any) =>
              formatCurrency(p.value || 0),
          },
          {
            field: "syncRevenue",
            headerName: "Sync Revenue",
            valueFormatter: (p: any) =>
              formatCurrency(p.value || 0),
          },
          {
            field: "physicalRevenue",
            headerName: "Physical Revenue",
            valueFormatter: (p: any) =>
              formatCurrency(p.value || 0),
          },
        ],
        defaultColDef: {
          flex: 1,
        },
        groupDefaultExpanded: 1,
        masterDetail: true,
        detailRowHeight: 0,
      },
      getDetailRowData: (params: any) => {
        params.successCallback(params.data.children);
      },
    } as IDetailCellRendererParams;
  }, []);

  const [columnDefs] = useState<any>([
    {
      field: "releaseName",
      headerName: "Release Name",
      cellRenderer: "agGroupCellRenderer",
    },
    { field: "releaseDate", headerName: "Release Date" },
    { field: "locale", headerName: "Locale" },
    { field: "trackCount", headerName: "Track Count", aggFunc: "sum" },
    {
      field: "totalRevenue",
      headerName: "Total Revenue",
      aggFunc: "sum",
      valueFormatter: (p: any) => formatCurrency(p.value),
    },
    {
      field: "totalExpenses",
      headerName: "Total Expenses",
      aggFunc: "sum",
      valueFormatter: (p: any) => formatCurrency(p.value),
    },
    {
      field: "netProfit",
      headerName: "Net Profit",
      aggFunc: "sum",
      valueFormatter: (p: any) => formatCurrency(p.value),
    },
    { field: "physicalCount", headerName: "Physical Count", aggFunc: "sum" },
    {
      field: "streamRevenue",
      headerName: "Stream Revenue",
      aggFunc: "sum",
      valueFormatter: (p: any) => formatCurrency(p.value),
    },
    {
      field: "syncRevenue",
      headerName: "Sync Revenue",
      aggFunc: "sum",
      valueFormatter: (p: any) => formatCurrency(p.value),
    },
    {
      field: "physicalRevenue",
      headerName: "Physical Revenue",
      aggFunc: "sum",
      valueFormatter: (p: any) => formatCurrency(p.value),
    },
  ]);

  //   const getData = async () => {
  //     try {
  //       const releases: Release[] = await apiClient.get("/release", {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
  //         },
  //       }).then(resp => resp.data);

  //       const finalOutput = new RecordingsDataRowAdapter().toRecordingsData(releases);
  //       setRowData(finalOutput);
  //     } catch (error) {
  //       setRowData([]);
  //       throw error;
  //     }
  //   };

  const cellSelection = useMemo(() => {
    return true;
  }, []);

  return (
    <div style={containerStyle}>
      <div style={gridStyle} className="ag-theme-quartz">
        <AgGridReact<RecordingsDataRow>
          rowData={rowData}
          masterDetail={true}
          columnDefs={columnDefs}
          sideBar={{ toolPanels: ["columns", "filters"] }}
          rowGroupPanelShow={"always"}
          enableCharts={true}
          cellSelection={cellSelection}
          defaultColDef={defaultColDef}
          detailCellRendererParams={detailCellRendererParams}
        />
      </div>
    </div>
  );
};

export default RecordedAnalytics;
